@let institutions = institutions$ | async;

@if (loading) {
  <div class="apg-loading">
    <ion-spinner></ion-spinner>
    <div>
      @if (mode == "institutions") {
        <i>Loading institutions...</i>
      } @else {
        <i>Retrieving account information...</i>
      }
    </div>
  </div>
} @else {
  @switch (mode) {
    @case ("institutions") {
      <div class="institutions">
        <div class="institutions__tip">
          <ion-label>Please select your banking institution</ion-label>
        </div>
        <div *ngFor="let institution of institutions">
          <div class="institutions__institution" (click)="selectInstitution(institution)">
            <img [src]="selectImage(institution)" />
          </div>
        </div>
      </div>
    }

    @case ("accounts") {
      <div class="institutions">
        <div class="institutions__tip">
          <ion-label>Please select your banking account</ion-label>
        </div>
        <ion-list>
          @for (account of accounts; track account.id) {
            <ion-item (click)="selectAccount(account)" detail="true">
              <ion-label>
                <h1>{{ account.id }}</h1>
                <p>{{ account.type }} ({{ account.currency }})</p>
              </ion-label>
            </ion-item>
          }
        </ion-list>
      </div>
    }
  }
}
